<template>
    <div class="wb-sidebar-menu-line-three-left">
        <div class="wb-sidebar-menu-price">
            {{price}} {{this.currencySymbol}}
        </div>
        <div class="wb-sidebar-menu-count">
            x {{count??0}}
        </div>
        <div class="wb-sidebar-menu-cost">
            {{cost}} {{this.currencySymbol}}
        </div>
    </div>
</template>
<script>

export default {
    name: 'SidebarMenuItemBot4',
    props: [
        'price',
        'count',
        'currencySymbol'
    ],
    computed: {
        cost() {
            let count = 0;
            let price = 0;
            if (this.count) {
                count = +this.count;
            }
            if (this.price) {
                price = +this.price;
            }
            return price * count;
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/fonts.scss";
@import "CSS/colors.scss";
@import "CSS/animations.scss";
@import "CSS/common.scss";

.wb-sidebar-menu-line-three-left {
    display: grid;
    grid-template-columns: max-content max-content auto;
    grid-column-gap: 8px;
    width: 100%;
}

.wb-dnd-on-hover-anchor {
    width: 0;
}

.wb-dnd-on-hover-visible {
    //display: none;
    position: relative;
    right: 24px;
    color: transparent;
    @include button-smooth;
}

.wb-sidebar-menu-item:hover .wb-dnd-on-hover-visible{
    color: $green2;
}

</style>
